// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'

import { UserProfileContent } from './UserProfileContent'
import { UserAvatar } from './UserAvatar'

const UserData = {
  id: 'user',
  // Avatar is not an icon, instead render as child of button
  // so button doesn't apply button font-weight/other styling to Avatar
  children: <UserAvatar />,
  content: <UserProfileContent />
}
export { UserData }
